<script>
import ValueComboBox from './ValueComboBox'

export default {
  name: 'CampaignObjectiveComboBox',
  components: {
    ValueComboBox
  },
  computed: {
    items() {
      return [
        { text: 'App Installs', value: 'APP_INSTALLS' },
        { text: 'Brand Awareness', value: 'BRAND_AWARENESS' },
        { text: 'Conversions', value: 'CONVERSIONS' },
        { text: 'Event Responses', value: 'EVENT_RESPONSES' },
        { text: 'Lead Generation', value: 'LEAD_GENERATION' },
        { text: 'Link Clicks', value: 'LINK_CLICKS' },
        { text: 'Local Awareness', value: 'LOCAL_AWARENESS' },
        { text: 'Messages', value: 'MESSAGES' },
        { text: 'Offer Claims', value: 'OFFER_CLAIMS' },
        { text: 'Page Likes', value: 'PAGE_LIKES' },
        { text: 'Post Engagement', value: 'POST_ENGAGEMENT' },
        { text: 'Product Catalog Sales', value: 'PRODUCT_CATALOG_SALES' },
        { text: 'Reach', value: 'REACH' },
        { text: 'Store Visits', value: 'STORE_VISITS' },
        { text: 'Video Views', value: 'VIDEO_VIEWS' }
      ]
    }
  }
}
</script>

<template>
  <value-combo-box @input="$emit('input', $event)" :items="items" label="Objective" v-bind="$attrs" />
</template>
